export const props = {
  // Values
  text: [Number, String],

  // Status
  selected: Boolean,
  disabled: Boolean,

  // Options
  color: {
    type: String,
    default: 'basic',
    validator: value => [
      'basic',
      'primary',
      'secondary',
      'success',
      'info',
      'warning',
      'error',
      'disabled',
      'black',
      'white',
      'medium'
    ].indexOf(value) !== -1
  },
  tag: {
    type: String,
    default: 'button'
  },
  appearance: {
    type: String,
    default: 'contained',
    validator: value => [
      'contained'
    ].indexOf(value) !== -1
  }
}
